import FaqCreate from "components/Cards/FaqCreate";
import React from "react";


export default function CreateFaq() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <FaqCreate />
        </div>
      </div>
    </>
  );
}
